var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "home-button", on: { click: _vm.goToDashboardPage } },
    [
      _c(
        "v-tooltip",
        {
          attrs: { bottom: "" },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function ({ on }) {
                return [
                  _c("div", _vm._g({ staticClass: "home-button__icon" }, on), [
                    _c(
                      "svg",
                      {
                        staticStyle: {
                          "enable-background": "new 0 0 1080 1080",
                        },
                        attrs: {
                          id: "Layer_1",
                          xmlns: "http://www.w3.org/2000/svg",
                          "xmlns:xlink": "http://www.w3.org/1999/xlink",
                          x: "0px",
                          y: "0px",
                          height: "256px",
                          viewBox: "0 0 1080 1080",
                          "xml:space": "preserve",
                        },
                      },
                      [
                        _c("g", [
                          _c("path", {
                            staticClass: "st693",
                            attrs: {
                              d: "M354.7,976.3c1.6,5,3.4,10,5.2,15c2.5,6.5,5.1,13.1,7.6,19.6c4.1,11,8.3,21.8,12.4,32.8h-16\n\t\tc-2.2-8.4-3-11.7-8.8-25.6h-25.8c-2.6,4.8-5.3,9.5-7.8,14.4c-1.8,3.7-3.6,7.4-5.2,11.2h-15.1l35.3-67.4H354.7z M333.9,1007.6H352\n\t\tl-7.6-20.9L333.9,1007.6z",
                            },
                          }),
                          _c("path", {
                            staticClass: "st693",
                            attrs: {
                              d: "M424.3,989c-5.5-1.4-11.2-3.1-16.9-3.1c-5,0-7.1,1.2-8.5,3.2c-0.3,0.4-1.1,1.6-1.1,3.1\n\t\tc0,2.6,2.1,4.5,3.9,6.2c3.6,2.9,7.1,5.8,10.7,8.8c2.8,2.4,5.5,4.9,8.2,7.4c1.6,1.8,5.7,5.7,5.7,12.5c0,2.6-0.7,8-5.9,12.4\n\t\tc-4.4,3.7-9.3,4.5-15,5.3c-11.1,0.2-13.7-0.3-24.1-3.3l-0.7-13c1.5,0.8,3,1.4,4.6,2.1c6.9,2.9,13.3,3.3,16.2,3.3\n\t\tc1.8,0,4.2-0.1,5.9-0.8c1-0.3,4.4-1.7,4.4-5.2c0-2.7-2.1-4.6-4.3-6.6c-2.2-1.9-4.4-3.8-6.6-5.7c-2.2-1.8-4.4-3.6-6.5-5.5\n\t\tc-1.4-1.3-2.9-2.7-4.3-4c-1.7-1.8-6.4-6.4-6.4-14c0-5.1,2.3-10.2,6.7-13.2c1.1-0.7,2.4-1.4,5-2.2c6.4-2,10.2-1.7,13.4-1.7\n\t\tc4.5,0.2,6.8,0.2,14.7,1.9L424.3,989z",
                            },
                          }),
                          _c("path", {
                            staticClass: "st693",
                            attrs: {
                              d: "M448.8,976.3l-1.7,27h36.2c0.4-5.3,0.7-10.6,0.9-15.9c0.1-3.7,0.2-7.4,0.3-11.2l15,0.1\n\t\tc-0.9,12.1-1.7,24.3-2.3,36.5c-0.5,10.2-0.7,20.5-0.9,30.8h-14.9c0.5-7,1.1-13.9,1.3-21c0.1-2.6,0.1-5.3,0.2-8l-36.2,0.1\n\t\tc-0.3,6.7-0.7,13.5-0.8,20.3c-0.1,2.8-0.1,5.7-0.2,8.6h-15.1c1-12.8,1.8-25.6,2.3-38.4c0.4-9.7,0.6-19.4,0.7-29H448.8z",
                            },
                          }),
                          _c("path", {
                            staticClass: "st693",
                            attrs: {
                              d: "M540.4,976.3c6.1,0.6,11.3,1.3,14.3,7c0.7,1.2,1.9,4.1,1.9,8.2c0,5.8-2.6,11.4-7.3,14.5\n\t\tc-1.4,1-2.6,1.5-6,2.6c1.6,0.3,3.8,0.8,5.3,1.3c8.8,3.3,9.2,11.3,9.2,14.3c0,1.1-0.1,2.6-0.6,4.8c-0.3,1.7-1.2,5.6-4.7,8.9\n\t\tc-1.7,1.7-3.7,3-5.9,3.8c-3.7,1.4-7.3,1.6-11.3,1.9h-30.4c0.6-6.2,1.2-12.3,1.4-18.6c0.6-9.7,0.8-19.4,1-29.1\n\t\tc0.1-6.5,0.2-13.1,0.3-19.7H540.4z M519.9,1032.7h12.5c3.9-0.3,7.2-0.5,9.6-3.7c0.8-1.1,1.9-2.9,1.9-5.9c0-1.3-0.1-4.4-2.9-6.5\n\t\tc-2.7-2.1-6.2-2-9.7-2h-10.5L519.9,1032.7z M520.9,1004.2h6.5c5.4-0.1,12-0.5,14.3-5.9c0.2-0.6,0.8-1.9,0.8-3.7\n\t\tc0-0.7-0.2-2.4-1.3-4c-2-2.8-5-2.9-8.4-3h-11.3L520.9,1004.2z",
                            },
                          }),
                          _c("path", {
                            staticClass: "st693",
                            attrs: {
                              d: "M561.9,1009.4c0.2-2.7,0.3-4.2,1.3-9.1c1.6-5.2,2.9-8.6,6.3-12.8c1.2-1.2,3.2-3.6,6.6-6\n\t\tc4.8-3.2,8.6-4.2,14-5.7c3.8-0.6,6.6-1,10.5-1c2.4,0,4.8,0.2,9.8,0.8c3.6,0.9,6.3,1.5,9.6,3c7.5,3.2,11.4,8.2,13.2,10.7\n\t\tc3.8,5.7,4.5,10.5,5.4,17.2c0.1,3.6,0.2,4.7-0.9,10.6c-1.1,4.5-1.7,6.5-2.7,8.7c-1.4,3.3-5.4,10.3-14,14.7c-4,2.1-7.7,3-12.1,3.9\n\t\tc-3,0.2-6,0.5-8.9,0.5c-3.1,0-6.2-0.4-9.2-0.7c-2.8-0.7-5.3-1.3-8-2.2c-3.3-1.2-11-4.5-16.2-12.8c-3.7-6-4.2-11-4.7-17.8V1009.4z\n\t\t M577.1,1018.9c3.3,10.2,12.4,14.5,22.9,14.5c1.7,0,6.9-0.1,11.6-2.2c8.7-3.8,13.1-12.2,13.1-21.6c-0.1-2.5-0.5-11.7-6.7-17.5\n\t\tc-2.5-2.2-8.2-5.7-16.8-5.7c-2.5,0-11.1,0.4-17.3,5.5c-3,2.5-7.8,8.4-7.9,18.8C575.8,1013.5,576.2,1016.4,577.1,1018.9z",
                            },
                          }),
                          _c("path", {
                            staticClass: "st693",
                            attrs: {
                              d: "M691.2,976.3c1.6,5,3.4,10,5.2,15c2.5,6.5,5.1,13.1,7.6,19.6c4.1,11,8.3,21.8,12.4,32.8h-16\n\t\tc-2.2-8.4-3-11.7-8.8-25.6h-25.8c-2.6,4.8-5.3,9.5-7.8,14.4c-1.8,3.7-3.6,7.4-5.2,11.2h-15.1l35.3-67.4H691.2z M670.4,1007.6h18.1\n\t\tl-7.6-20.9L670.4,1007.6z",
                            },
                          }),
                          _c("path", {
                            staticClass: "st693",
                            attrs: {
                              d: "M757.3,976.6c4.2,0.4,8.2,0.9,11.5,3.6c2.1,1.6,5.9,6,5.9,13.4c0,1-0.1,3.1-0.8,5.5\n\t\tc-0.7,2.6-2.8,8.6-8.9,12.4c-2.2,1.3-5.2,2.5-7.7,3.4l14.3,28.9h-16.3c-1.5-4-3.1-8-4.9-11.9c-1.7-3.9-3.7-7.9-5.5-11.7\n\t\tc-2.3-4.7-4.5-9.4-6.7-14c2.2,0.2,4.4,0.4,6.6,0.4c1.7,0,9.3-0.1,13.1-5.4c1.7-2.5,1.9-5.1,1.9-6.3c0-1.1-0.2-4-2.5-5.9\n\t\tc-1.4-1.2-2.7-1.5-6.5-1.7l-14.4,0.1c-0.9,13.2-1.6,26.3-2,39.5c-0.2,5.7-0.3,11.2-0.4,16.8h-14.8c0.7-7.2,1.2-14.4,1.5-21.7\n\t\tc0.3-5.6,0.5-11.2,0.7-16.8c0.3-6,0.6-11.8,0.7-17.8c0.1-3.6,0.1-7.1,0.1-10.7H757.3z",
                            },
                          }),
                          _c("path", {
                            staticClass: "st693",
                            attrs: {
                              d: "M793.1,976.3c4.2-0.1,8.5-0.3,12.6-0.3c4.3,0,8.6,0.2,12.8,0.4c6.2,1,10.3,1.8,14.8,6.3\n\t\tc3,2.9,4.6,6.2,5.2,7.5c3,6.7,2.9,13,2.7,20.4c-0.6,6.6-0.9,8.1-2.8,14.4c-0.3,0.8-0.6,1.5-1,2.3c-1.2,2.6-3.9,8.8-10.9,12.7\n\t\tc-2.9,1.6-5.2,2.3-11.4,3.2c-5.2,0.3-10.3,0.6-15.6,0.6c-2.9,0-5.9-0.1-8.8-0.1c-4.4,0-8.8,0-13.3,0.1c0.5-5.8,1.1-11.5,1.3-17.3\n\t\tc0.2-4.7,0.3-9.4,0.6-14.1c0.3-6.6,0.7-13.4,0.9-20.1c0.2-5.3,0.2-10.6,0.3-15.9H793.1z M792.2,1032.1c4.4,0,8.9,0.1,13.3-0.2\n\t\tl4.9-0.3c0.3-0.1,3.1-0.5,4.8-1.2c1.6-0.6,5.2-2.1,7.8-6.2c3-4.6,4.6-11.9,4.6-17.3c0-2.9-0.3-14.3-10.7-18.1\n\t\tc-2.4-0.9-4.4-1-6.9-1.2h-15.8L792.2,1032.1z",
                            },
                          }),
                        ]),
                        _c("g", [
                          _c("g", [
                            _c("g", [
                              _c("path", {
                                staticClass: "st708",
                                attrs: {
                                  d: "M602.9,167.3C602.8,167.3,602.8,167.3,602.9,167.3l-0.1,0l0,0c-0.8-0.3-1.9-0.1-3,0.5l-146,84.3\n\t\t\t\tc-2.7,1.5-4.8,5.3-4.8,8.3v12.8v97.5c0,1.6,0.6,2.7,1.5,3.1l0,0l0.1,0c0.1,0.1,0.3,0.1,0.4,0.2l1.7-0.1c0.4-0.1,0.8-0.3,1.2-0.5\n\t\t\t\tl146-84.3c2.7-1.5,4.8-5.3,4.8-8.3v-97.5v-12.8c0-1-0.2-1.8-0.7-2.4L602.9,167.3z",
                                },
                              }),
                            ]),
                            _c("path", {
                              staticClass: "st709",
                              attrs: {
                                d: "M702.3,104.3l-3.9-1.5c0,0-0.1,0-0.1,0l-0.1,0l0,0c-1.6-0.5-3.6-0.2-5.8,1L405.8,269.3\n\t\t\tc-5.2,3-9.4,10.3-9.4,16.4v25.2v191.4c0,3.1,1.1,5.2,2.9,6.2l0,0l0.1,0c0.3,0.1,0.5,0.2,0.8,0.3l3.4,1.3l0-1.4\n\t\t\tc0.7-0.2,1.5-0.5,2.3-1l286.6-165.4c5.2-3,9.4-10.3,9.4-16.4V134.5v-25.2c0-2-0.5-3.6-1.3-4.7L702.3,104.3z",
                              },
                            }),
                            _c("g", [
                              _c("path", {
                                staticClass: "st697",
                                attrs: {
                                  d: "M400.3,312.3v191.4c0,6,4.2,8.5,9.4,5.5l286.6-165.4c5.2-3,9.4-10.3,9.4-16.4V135.9L400.3,312.3z",
                                },
                              }),
                              _c("path", {
                                staticClass: "st702",
                                attrs: {
                                  d: "M705.8,110.8c0-6-4.2-8.5-9.4-5.5L409.7,270.7c-5.2,3-9.4,10.3-9.4,16.4v25.2l305.5-176.4V110.8z",
                                },
                              }),
                            ]),
                            _c("g", [
                              _c("path", {
                                staticClass: "st406",
                                attrs: {
                                  d: "M662,143.2c0,2.6-1.8,5.8-4.1,7.2c-2.3,1.3-4.1,0.2-4.1-2.4c0-2.6,1.8-5.8,4.1-7.2\n\t\t\t\tC660.1,139.5,662,140.5,662,143.2z",
                                },
                              }),
                              _c("path", {
                                staticClass: "st406",
                                attrs: {
                                  d: "M676.9,134.5c0,2.6-1.8,5.8-4.1,7.2s-4.1,0.2-4.1-2.4c0-2.6,1.8-5.8,4.1-7.2\n\t\t\t\tC675.1,130.8,676.9,131.9,676.9,134.5z",
                                },
                              }),
                              _c("path", {
                                staticClass: "st406",
                                attrs: {
                                  d: "M691.9,125.9c0,2.6-1.8,5.8-4.1,7.2c-2.3,1.3-4.1,0.2-4.1-2.4c0-2.6,1.8-5.8,4.1-7.2\n\t\t\t\tC690.1,122.2,691.9,123.2,691.9,125.9z",
                                },
                              }),
                            ]),
                            _c("polygon", {
                              staticClass: "st706",
                              attrs: {
                                points:
                                  "498.3,384.2 424.6,427.9 424.6,379.5 498.3,335.8 \t\t",
                              },
                            }),
                            _c(
                              "g",
                              [
                                _c(
                                  "g",
                                  [
                                    _c(
                                      "linearGradient",
                                      {
                                        attrs: {
                                          id: "SVGID_00000155835951113341818820000001492619998238346430_",
                                          gradientUnits: "userSpaceOnUse",
                                          x1: "1217.6221",
                                          y1: "2825.5488",
                                          x2: "1222.8665",
                                          y2: "2816.4651",
                                          gradientTransform:
                                            "matrix(0.866 -0.5 0 1.1547 -628.4642 -2199.9353)",
                                        },
                                      },
                                      [
                                        _c("stop", {
                                          staticStyle: {
                                            "stop-color": "#66BC52",
                                          },
                                          attrs: { offset: "0" },
                                        }),
                                        _c("stop", {
                                          staticStyle: {
                                            "stop-color": "#3B60AB",
                                          },
                                          attrs: { offset: "1" },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c("polygon", {
                                      staticStyle: {
                                        fill: "url(#SVGID_00000155835951113341818820000001492619998238346430_)",
                                      },
                                      attrs: {
                                        points:
                                          "431.9,449.5 424.6,453.7\n\t\t\t\t\t424.6,445.3 431.9,441.1 \t\t\t\t",
                                      },
                                    }),
                                    _c("polygon", {
                                      staticClass: "st711",
                                      attrs: {
                                        points:
                                          "457.5,434.5 431.9,449.5 431.9,441.1 457.5,426.1 \t\t\t\t",
                                      },
                                    }),
                                    _c("polygon", {
                                      staticClass: "st711",
                                      attrs: {
                                        points:
                                          "457.5,445.6 431.9,460.5 431.9,452.1 457.5,437.2 \t\t\t\t",
                                      },
                                    }),
                                    _c("polygon", {
                                      staticClass: "st711",
                                      attrs: {
                                        points:
                                          "457.5,457.1 431.9,472 431.9,463.6 457.5,448.7 \t\t\t\t",
                                      },
                                    }),
                                    _c(
                                      "linearGradient",
                                      {
                                        attrs: {
                                          id: "SVGID_00000111160158961827755650000013442709410423107234_",
                                          gradientUnits: "userSpaceOnUse",
                                          x1: "1217.6219",
                                          y1: "2835.0901",
                                          x2: "1222.8665",
                                          y2: "2826.0063",
                                          gradientTransform:
                                            "matrix(0.866 -0.5 0 1.1547 -628.4642 -2199.9353)",
                                        },
                                      },
                                      [
                                        _c("stop", {
                                          staticStyle: {
                                            "stop-color": "#F7D322",
                                          },
                                          attrs: { offset: "0" },
                                        }),
                                        _c("stop", {
                                          staticStyle: {
                                            "stop-color": "#EF5153",
                                          },
                                          attrs: { offset: "1" },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c("polygon", {
                                      staticStyle: {
                                        fill: "url(#SVGID_00000111160158961827755650000013442709410423107234_)",
                                      },
                                      attrs: {
                                        points:
                                          "431.9,460.5 424.6,464.7\n\t\t\t\t\t424.6,456.3 431.9,452.1 \t\t\t\t",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "linearGradient",
                                  {
                                    attrs: {
                                      id: "SVGID_00000120516955154571879620000005036144643636006016_",
                                      gradientUnits: "userSpaceOnUse",
                                      x1: "1217.6221",
                                      y1: "2845.0894",
                                      x2: "1222.8665",
                                      y2: "2836.0059",
                                      gradientTransform:
                                        "matrix(0.866 -0.5 0 1.1547 -628.4642 -2199.9353)",
                                    },
                                  },
                                  [
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#EF5D7D" },
                                      attrs: { offset: "0" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#6D7CBB" },
                                      attrs: { offset: "1" },
                                    }),
                                  ],
                                  1
                                ),
                                _c("polygon", {
                                  staticStyle: {
                                    fill: "url(#SVGID_00000120516955154571879620000005036144643636006016_)",
                                  },
                                  attrs: {
                                    points:
                                      "431.9,472 424.6,476.2\n\t\t\t\t424.6,467.8 431.9,463.6 \t\t\t",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "g",
                              [
                                _c(
                                  "linearGradient",
                                  {
                                    attrs: {
                                      id: "SVGID_00000080918915794823566460000015028336426427251378_",
                                      gradientUnits: "userSpaceOnUse",
                                      x1: "472.2697",
                                      y1: "425.5295",
                                      x2: "497.9081",
                                      y2: "425.5295",
                                    },
                                  },
                                  [
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#1F715C" },
                                      attrs: { offset: "1.071477e-03" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#237761" },
                                      attrs: { offset: "0.2003" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#2D8A70" },
                                      attrs: { offset: "0.4783" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#3DA788" },
                                      attrs: { offset: "0.8012" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#49BD99" },
                                      attrs: { offset: "1" },
                                    }),
                                  ],
                                  1
                                ),
                                _c("polygon", {
                                  staticStyle: {
                                    fill: "url(#SVGID_00000080918915794823566460000015028336426427251378_)",
                                  },
                                  attrs: {
                                    points:
                                      "497.9,422.3 472.3,437.2\n\t\t\t\t472.3,428.8 497.9,413.9 \t\t\t",
                                  },
                                }),
                                _c(
                                  "linearGradient",
                                  {
                                    attrs: {
                                      id: "SVGID_00000154385708765579587510000017725289534970217881_",
                                      gradientUnits: "userSpaceOnUse",
                                      x1: "472.2697",
                                      y1: "437.0756",
                                      x2: "497.9081",
                                      y2: "437.0756",
                                    },
                                  },
                                  [
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#1F715C" },
                                      attrs: { offset: "1.071477e-03" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#237761" },
                                      attrs: { offset: "0.2003" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#2D8A70" },
                                      attrs: { offset: "0.4783" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#3DA788" },
                                      attrs: { offset: "0.8012" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#49BD99" },
                                      attrs: { offset: "1" },
                                    }),
                                  ],
                                  1
                                ),
                                _c("polygon", {
                                  staticStyle: {
                                    fill: "url(#SVGID_00000154385708765579587510000017725289534970217881_)",
                                  },
                                  attrs: {
                                    points:
                                      "497.9,433.8 472.3,448.7\n\t\t\t\t472.3,440.3 497.9,425.4 \t\t\t",
                                  },
                                }),
                                _c(
                                  "linearGradient",
                                  {
                                    attrs: {
                                      id: "SVGID_00000003105783508781461670000016078737958109692314_",
                                      gradientUnits: "userSpaceOnUse",
                                      x1: "472.2697",
                                      y1: "414.5122",
                                      x2: "497.9081",
                                      y2: "414.5122",
                                    },
                                  },
                                  [
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#1F715C" },
                                      attrs: { offset: "1.071477e-03" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#237761" },
                                      attrs: { offset: "0.2003" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#2D8A70" },
                                      attrs: { offset: "0.4783" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#3DA788" },
                                      attrs: { offset: "0.8012" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#49BD99" },
                                      attrs: { offset: "1" },
                                    }),
                                  ],
                                  1
                                ),
                                _c("polygon", {
                                  staticStyle: {
                                    fill: "url(#SVGID_00000003105783508781461670000016078737958109692314_)",
                                  },
                                  attrs: {
                                    points:
                                      "497.9,411.2 472.3,426.2\n\t\t\t\t472.3,417.8 497.9,402.9 \t\t\t",
                                  },
                                }),
                                _c("polygon", {
                                  staticClass: "st717",
                                  attrs: {
                                    points:
                                      "472.3,426.2 465,430.4 465,422 472.3,417.8 \t\t\t",
                                  },
                                }),
                                _c("polygon", {
                                  staticClass: "st717",
                                  attrs: {
                                    points:
                                      "472.3,437.2 465,441.4 465,433 472.3,428.8 \t\t\t",
                                  },
                                }),
                                _c("polygon", {
                                  staticClass: "st717",
                                  attrs: {
                                    points:
                                      "472.3,448.7 465,452.9 465,444.5 472.3,440.3 \t\t\t",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c("g", [
                              _c("path", {
                                staticClass: "st717",
                                attrs: {
                                  d: "M613.8,236.1L613.8,236.1l0-28.7c-32.7,18.9-60.2,60.1-68.7,99.6l24-6\n\t\t\t\tC574.7,275.2,592.6,248.3,613.8,236.1z",
                                },
                              }),
                              _c("path", {
                                staticClass: "st718",
                                attrs: {
                                  d: "M567.4,316.6c0-5.1,0.7-10.3,1.8-15.6l-24,6c-1.7,8.1-2.7,16.2-2.7,24c0,0.6,0,1.2,0,1.8l24.9-15\n\t\t\t\tC567.4,317.3,567.4,317,567.4,316.6z",
                                },
                              }),
                              _c("path", {
                                staticClass: "st704",
                                attrs: {
                                  d: "M657.4,246.2l23.5-23.4c-10-25.8-36.2-33.3-67.1-15.5v28.7C633.9,224.5,650.9,229.4,657.4,246.2z",
                                },
                              }),
                              _c("path", {
                                staticClass: "st719",
                                attrs: {
                                  d: "M680.9,222.8l-23.5,23.4c1.8,4.7,2.9,10.2,2.9,16.7c0,1.4-0.1,2.8-0.2,4.3l24.8-12.1\n\t\t\t\tc0.1-2.2,0.2-4.4,0.2-6.5C685.2,238.6,683.7,230,680.9,222.8z",
                                },
                              }),
                              _c("path", {
                                staticClass: "st702",
                                attrs: {
                                  d: "M613.8,343.4c-25.3,14.6-45.9,3-46.4-25.7l-24.9,15c0.8,44.2,32.4,61.8,71.3,39.4\n\t\t\t\tc7.2-4.1,14.1-9.3,20.6-15.4l-7.2-23.4C623,337.3,618.5,340.7,613.8,343.4z",
                                },
                              }),
                              _c("path", {
                                staticClass: "st720",
                                attrs: {
                                  d: "M627.2,333.4l7.2,23.4c27.7-25.6,48.3-66,50.5-101.7l-24.8,12.1C658.6,290.4,645.2,316.7,627.2,333.4z",
                                },
                              }),
                            ]),
                            _c(
                              "g",
                              [
                                _c(
                                  "linearGradient",
                                  {
                                    attrs: {
                                      id: "SVGID_00000176001253106844903300000004296813598058815893_",
                                      gradientUnits: "userSpaceOnUse",
                                      x1: "1205.8062",
                                      y1: "2701.3489",
                                      x2: "1205.8062",
                                      y2: "2672.1973",
                                      gradientTransform:
                                        "matrix(0.866 -0.5 0 1.1547 -611.8783 -2158.238)",
                                    },
                                  },
                                  [
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#1F715C" },
                                      attrs: { offset: "1.071477e-03" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#237761" },
                                      attrs: { offset: "0.2003" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#2D8A70" },
                                      attrs: { offset: "0.4783" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#3DA788" },
                                      attrs: { offset: "0.8012" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#49BD99" },
                                      attrs: { offset: "1" },
                                    }),
                                  ],
                                  1
                                ),
                                _c("polygon", {
                                  staticStyle: {
                                    fill: "url(#SVGID_00000176001253106844903300000004296813598058815893_)",
                                  },
                                  attrs: {
                                    points:
                                      "428.7,326.5 436,322.4 436,356\n\t\t\t\t428.7,360.2 \t\t\t",
                                  },
                                }),
                                _c(
                                  "linearGradient",
                                  {
                                    attrs: {
                                      id: "SVGID_00000139981361626861124010000003892534581985576368_",
                                      gradientUnits: "userSpaceOnUse",
                                      x1: "1246.1626",
                                      y1: "2701.3513",
                                      x2: "1246.1626",
                                      y2: "2677.9949",
                                      gradientTransform:
                                        "matrix(0.866 -0.5 0 1.1547 -611.8783 -2158.238)",
                                    },
                                  },
                                  [
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#1F715C" },
                                      attrs: { offset: "1.071477e-03" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#237761" },
                                      attrs: { offset: "0.2003" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#2D8A70" },
                                      attrs: { offset: "0.4783" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#3DA788" },
                                      attrs: { offset: "0.8012" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#49BD99" },
                                      attrs: { offset: "1" },
                                    }),
                                  ],
                                  1
                                ),
                                _c("polygon", {
                                  staticStyle: {
                                    fill: "url(#SVGID_00000139981361626861124010000003892534581985576368_)",
                                  },
                                  attrs: {
                                    points:
                                      "463.7,313 470.9,308.9\n\t\t\t\t470.9,335.8 463.7,340 \t\t\t",
                                  },
                                }),
                                _c(
                                  "linearGradient",
                                  {
                                    attrs: {
                                      id: "SVGID_00000000213953080542322810000001429982148584569498_",
                                      gradientUnits: "userSpaceOnUse",
                                      x1: "1259.6147",
                                      y1: "2701.3503",
                                      x2: "1259.6147",
                                      y2: "2686.7803",
                                      gradientTransform:
                                        "matrix(0.866 -0.5 0 1.1547 -611.8783 -2158.238)",
                                    },
                                  },
                                  [
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#1F715C" },
                                      attrs: { offset: "1.071477e-03" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#237761" },
                                      attrs: { offset: "0.2003" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#2D8A70" },
                                      attrs: { offset: "0.4783" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#3DA788" },
                                      attrs: { offset: "0.8012" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#49BD99" },
                                      attrs: { offset: "1" },
                                    }),
                                  ],
                                  1
                                ),
                                _c("polygon", {
                                  staticStyle: {
                                    fill: "url(#SVGID_00000000213953080542322810000001429982148584569498_)",
                                  },
                                  attrs: {
                                    points:
                                      "475.3,316.5 482.6,312.3\n\t\t\t\t482.6,329.1 475.3,333.3 \t\t\t",
                                  },
                                }),
                                _c(
                                  "linearGradient",
                                  {
                                    attrs: {
                                      id: "SVGID_00000173139311248538536700000009539441731229239726_",
                                      gradientUnits: "userSpaceOnUse",
                                      x1: "1219.2583",
                                      y1: "2701.3479",
                                      x2: "1219.2583",
                                      y2: "2686.1482",
                                      gradientTransform:
                                        "matrix(0.866 -0.5 0 1.1547 -611.8783 -2158.238)",
                                    },
                                  },
                                  [
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#1F715C" },
                                      attrs: { offset: "1.071477e-03" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#237761" },
                                      attrs: { offset: "0.2003" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#2D8A70" },
                                      attrs: { offset: "0.4783" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#3DA788" },
                                      attrs: { offset: "0.8012" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#49BD99" },
                                      attrs: { offset: "1" },
                                    }),
                                  ],
                                  1
                                ),
                                _c("polygon", {
                                  staticStyle: {
                                    fill: "url(#SVGID_00000173139311248538536700000009539441731229239726_)",
                                  },
                                  attrs: {
                                    points:
                                      "440.4,335.9 447.6,331.7\n\t\t\t\t447.6,349.3 440.4,353.5 \t\t\t",
                                  },
                                }),
                                _c(
                                  "linearGradient",
                                  {
                                    attrs: {
                                      id: "SVGID_00000045589304277776322410000001072471386547971481_",
                                      gradientUnits: "userSpaceOnUse",
                                      x1: "1273.0668",
                                      y1: "2701.3511",
                                      x2: "1273.0668",
                                      y2: "2676.0425",
                                      gradientTransform:
                                        "matrix(0.866 -0.5 0 1.1547 -611.8783 -2158.238)",
                                    },
                                  },
                                  [
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#1F715C" },
                                      attrs: { offset: "1.071477e-03" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#237761" },
                                      attrs: { offset: "0.2003" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#2D8A70" },
                                      attrs: { offset: "0.4783" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#3DA788" },
                                      attrs: { offset: "0.8012" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#49BD99" },
                                      attrs: { offset: "1" },
                                    }),
                                  ],
                                  1
                                ),
                                _c("polygon", {
                                  staticStyle: {
                                    fill: "url(#SVGID_00000045589304277776322410000001072471386547971481_)",
                                  },
                                  attrs: {
                                    points:
                                      "487,297.3 494.2,293.2\n\t\t\t\t494.2,322.4 487,326.6 \t\t\t",
                                  },
                                }),
                                _c(
                                  "linearGradient",
                                  {
                                    attrs: {
                                      id: "SVGID_00000170252922618597246300000009982885160858838969_",
                                      gradientUnits: "userSpaceOnUse",
                                      x1: "1232.7104",
                                      y1: "2701.3506",
                                      x2: "1232.7104",
                                      y2: "2659.6382",
                                      gradientTransform:
                                        "matrix(0.866 -0.5 0 1.1547 -611.8783 -2158.238)",
                                    },
                                  },
                                  [
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#1F715C" },
                                      attrs: { offset: "1.071477e-03" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#237761" },
                                      attrs: { offset: "0.2003" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#2D8A70" },
                                      attrs: { offset: "0.4783" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#3DA788" },
                                      attrs: { offset: "0.8012" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#49BD99" },
                                      attrs: { offset: "1" },
                                    }),
                                  ],
                                  1
                                ),
                                _c("polygon", {
                                  staticStyle: {
                                    fill: "url(#SVGID_00000170252922618597246300000009982885160858838969_)",
                                  },
                                  attrs: {
                                    points:
                                      "452,298.6 459.3,294.4\n\t\t\t\t459.3,342.6 452,346.7 \t\t\t",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                          _c("g", [
                            _c("path", {
                              staticClass: "st709",
                              attrs: {
                                d: "M492.2,405.8l-3.9-1.5c0,0-0.1,0-0.1,0l-0.1,0l0,0c-1.6-0.5-3.6-0.2-5.8,1L195.7,570.8\n\t\t\tc-5.2,3-9.4,10.3-9.4,16.4v25.2v191.4c0,3.1,1.1,5.2,2.9,6.2l0,0l0.1,0c0.3,0.1,0.5,0.2,0.8,0.3l3.4,1.3l0-1.4\n\t\t\tc0.7-0.2,1.5-0.5,2.3-1l286.6-165.4c5.2-3,9.4-10.3,9.4-16.4V436v-25.2c0-2-0.5-3.6-1.3-4.7L492.2,405.8z",
                              },
                            }),
                            _c("g", [
                              _c("path", {
                                staticClass: "st697",
                                attrs: {
                                  d: "M190.4,613.9v191.4c0,6,4.2,8.5,9.4,5.5l286.6-165.4c5.2-3,9.4-10.3,9.4-16.4V437.5L190.4,613.9z",
                                },
                              }),
                              _c("path", {
                                staticClass: "st406",
                                attrs: {
                                  d: "M495.8,413c0-6-4.2-8.5-9.4-5.5L199.8,573c-5.2,3-9.4,10.3-9.4,16.4v25.2l305.5-176.4V413z",
                                },
                              }),
                            ]),
                            _c("g", [
                              _c("path", {
                                staticClass: "st727",
                                attrs: {
                                  d: "M452,444.7c0,2.6-1.8,5.8-4.1,7.2c-2.3,1.3-4.1,0.2-4.1-2.4c0-2.6,1.8-5.8,4.1-7.2\n\t\t\t\tC450.2,441,452,442.1,452,444.7z",
                                },
                              }),
                              _c("path", {
                                staticClass: "st728",
                                attrs: {
                                  d: "M467,436.1c0,2.6-1.8,5.8-4.1,7.2c-2.3,1.3-4.1,0.2-4.1-2.4c0-2.6,1.8-5.8,4.1-7.2\n\t\t\t\tC465.1,432.4,467,433.5,467,436.1z",
                                },
                              }),
                              _c("path", {
                                staticClass: "st729",
                                attrs: {
                                  d: "M482,427.5c0,2.6-1.8,5.8-4.1,7.2c-2.3,1.3-4.1,0.2-4.1-2.4c0-2.6,1.8-5.8,4.1-7.2\n\t\t\t\tC480.1,423.7,482,424.8,482,427.5z",
                                },
                              }),
                            ]),
                            _c("polygon", {
                              staticClass: "st730",
                              attrs: {
                                points:
                                  "489.1,531.1 415.4,574.8 415.4,557.1 489.1,513.4 \t\t",
                              },
                            }),
                            _c("polygon", {
                              staticClass: "st730",
                              attrs: {
                                points:
                                  "489.1,565.9 415.4,609.6 415.4,591.9 489.1,548.1 \t\t",
                              },
                            }),
                            _c("polygon", {
                              staticClass: "st730",
                              attrs: {
                                points:
                                  "489.1,631.3 415.4,675 415.4,626.6 489.1,582.9 \t\t",
                              },
                            }),
                            _c(
                              "g",
                              [
                                _c(
                                  "linearGradient",
                                  {
                                    attrs: {
                                      id: "SVGID_00000137131799013945606260000007625749749184032429_",
                                      gradientUnits: "userSpaceOnUse",
                                      x1: "-8801.7412",
                                      y1: "-5571.4829",
                                      x2: "-8801.7412",
                                      y2: "-5591.6909",
                                      gradientTransform:
                                        "matrix(-1.400000e-03 -1 -0.9992 0.5787 -5376.395 -4878.207)",
                                    },
                                  },
                                  [
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#1F715C" },
                                      attrs: { offset: "1.071477e-03" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#237761" },
                                      attrs: { offset: "0.2003" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#2D8A70" },
                                      attrs: { offset: "0.4783" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#3DA788" },
                                      attrs: { offset: "0.8012" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#49BD99" },
                                      attrs: { offset: "1" },
                                    }),
                                  ],
                                  1
                                ),
                                _c("polygon", {
                                  staticStyle: {
                                    fill: "url(#SVGID_00000137131799013945606260000007625749749184032429_)",
                                  },
                                  attrs: {
                                    points:
                                      "223.2,692.6 223.1,682.6\n\t\t\t\t202.9,694.3 203,704.3 \t\t\t",
                                  },
                                }),
                                _c(
                                  "linearGradient",
                                  {
                                    attrs: {
                                      id: "SVGID_00000099654804986806120090000011344025560073978302_",
                                      gradientUnits: "userSpaceOnUse",
                                      x1: "-8785.6758",
                                      y1: "-5571.4829",
                                      x2: "-8785.6758",
                                      y2: "-5599.3779",
                                      gradientTransform:
                                        "matrix(-1.400000e-03 -1 -0.9992 0.5787 -5376.395 -4878.207)",
                                    },
                                  },
                                  [
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#6B59A6" },
                                      attrs: { offset: "1.071477e-03" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#695FA5" },
                                      attrs: { offset: "0.1675" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#6371A3" },
                                      attrs: { offset: "0.3997" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#598F9F" },
                                      attrs: { offset: "0.6707" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#4BB89A" },
                                      attrs: { offset: "0.969" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#49BD99" },
                                      attrs: { offset: "1" },
                                    }),
                                  ],
                                  1
                                ),
                                _c("polygon", {
                                  staticStyle: {
                                    fill: "url(#SVGID_00000099654804986806120090000011344025560073978302_)",
                                  },
                                  attrs: {
                                    points:
                                      "230.8,672.1 230.8,662.1\n\t\t\t\t202.9,678.3 202.9,688.2 \t\t\t",
                                  },
                                }),
                                _c(
                                  "linearGradient",
                                  {
                                    attrs: {
                                      id: "SVGID_00000163778245413146288640000011217776933967032740_",
                                      gradientUnits: "userSpaceOnUse",
                                      x1: "-8737.4795",
                                      y1: "-5571.4834",
                                      x2: "-8737.4795",
                                      y2: "-5608.0049",
                                      gradientTransform:
                                        "matrix(-1.400000e-03 -1 -0.9992 0.5787 -5376.395 -4878.207)",
                                    },
                                  },
                                  [
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#1F715C" },
                                      attrs: { offset: "1.071477e-03" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#237761" },
                                      attrs: { offset: "0.2003" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#2D8A70" },
                                      attrs: { offset: "0.4783" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#3DA788" },
                                      attrs: { offset: "0.8012" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#49BD99" },
                                      attrs: { offset: "1" },
                                    }),
                                  ],
                                  1
                                ),
                                _c("polygon", {
                                  staticStyle: {
                                    fill: "url(#SVGID_00000163778245413146288640000011217776933967032740_)",
                                  },
                                  attrs: {
                                    points:
                                      "239.4,618.9 239.3,608.9\n\t\t\t\t202.9,630.1 202.9,640 \t\t\t",
                                  },
                                }),
                                _c(
                                  "linearGradient",
                                  {
                                    attrs: {
                                      id: "SVGID_00000119113226593048653870000010277637027391770241_",
                                      gradientUnits: "userSpaceOnUse",
                                      x1: "-8753.5449",
                                      y1: "-5571.4839",
                                      x2: "-8753.5449",
                                      y2: "-5589.6372",
                                      gradientTransform:
                                        "matrix(-1.400000e-03 -1 -0.9992 0.5787 -5376.395 -4878.207)",
                                    },
                                  },
                                  [
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#6B59A6" },
                                      attrs: { offset: "1.071477e-03" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#695FA5" },
                                      attrs: { offset: "0.1675" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#6371A3" },
                                      attrs: { offset: "0.3997" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#598F9F" },
                                      attrs: { offset: "0.6707" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#4BB89A" },
                                      attrs: { offset: "0.969" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#49BD99" },
                                      attrs: { offset: "1" },
                                    }),
                                  ],
                                  1
                                ),
                                _c("polygon", {
                                  staticStyle: {
                                    fill: "url(#SVGID_00000119113226593048653870000010277637027391770241_)",
                                  },
                                  attrs: {
                                    points:
                                      "221,645.6 221,635.6\n\t\t\t\t202.9,646.1 202.9,656.1 \t\t\t",
                                  },
                                }),
                                _c(
                                  "linearGradient",
                                  {
                                    attrs: {
                                      id: "SVGID_00000057132889193191043130000000437357553432852110_",
                                      gradientUnits: "userSpaceOnUse",
                                      x1: "-8721.4141",
                                      y1: "-5571.4829",
                                      x2: "-8721.4141",
                                      y2: "-5582.7876",
                                      gradientTransform:
                                        "matrix(-1.400000e-03 -1 -0.9992 0.5787 -5376.395 -4878.207)",
                                    },
                                  },
                                  [
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#6B59A6" },
                                      attrs: { offset: "1.071477e-03" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#695FA5" },
                                      attrs: { offset: "0.1675" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#6371A3" },
                                      attrs: { offset: "0.3997" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#598F9F" },
                                      attrs: { offset: "0.6707" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#4BB89A" },
                                      attrs: { offset: "0.969" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#49BD99" },
                                      attrs: { offset: "1" },
                                    }),
                                  ],
                                  1
                                ),
                                _c("polygon", {
                                  staticStyle: {
                                    fill: "url(#SVGID_00000057132889193191043130000000437357553432852110_)",
                                  },
                                  attrs: {
                                    points:
                                      "214.1,617.4 214.1,607.5\n\t\t\t\t202.8,614 202.8,624 \t\t\t",
                                  },
                                }),
                                _c(
                                  "linearGradient",
                                  {
                                    attrs: {
                                      id: "SVGID_00000173841923868663025050000013836712735526471301_",
                                      gradientUnits: "userSpaceOnUse",
                                      x1: "-8769.6104",
                                      y1: "-5571.4824",
                                      x2: "-8769.6104",
                                      y2: "-5621.3003",
                                      gradientTransform:
                                        "matrix(-1.400000e-03 -1 -0.9992 0.5787 -5376.395 -4878.207)",
                                    },
                                  },
                                  [
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#1F715C" },
                                      attrs: { offset: "1.071477e-03" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#237761" },
                                      attrs: { offset: "0.2003" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#2D8A70" },
                                      attrs: { offset: "0.4783" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#3DA788" },
                                      attrs: { offset: "0.8012" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#49BD99" },
                                      attrs: { offset: "1" },
                                    }),
                                  ],
                                  1
                                ),
                                _c("polygon", {
                                  staticStyle: {
                                    fill: "url(#SVGID_00000173841923868663025050000013836712735526471301_)",
                                  },
                                  attrs: {
                                    points:
                                      "252.7,643.3 252.7,633.4\n\t\t\t\t202.9,662.2 202.9,672.2 \t\t\t",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c("polygon", {
                              staticClass: "st730",
                              attrs: {
                                points:
                                  "273.3,753.9 202.8,794.4 202.8,776.7 273.3,736.2 \t\t",
                              },
                            }),
                            _c("polygon", {
                              staticClass: "st730",
                              attrs: {
                                points:
                                  "273.3,718.1 202.8,758.6 202.8,717.4 273.3,676.9 \t\t",
                              },
                            }),
                            _c("g", [
                              _c(
                                "g",
                                [
                                  _c("polygon", {
                                    staticClass: "st737",
                                    attrs: {
                                      points:
                                        "422.6,512.1 415.4,516.3 415.4,507.9 422.6,503.7 \t\t\t\t",
                                    },
                                  }),
                                  _c(
                                    "linearGradient",
                                    {
                                      attrs: {
                                        id: "SVGID_00000078734232224021332850000006457966955584513725_",
                                        gradientUnits: "userSpaceOnUse",
                                        x1: "422.6473",
                                        y1: "500.4079",
                                        x2: "448.2858",
                                        y2: "500.4079",
                                      },
                                    },
                                    [
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#1F715C",
                                        },
                                        attrs: { offset: "1.071477e-03" },
                                      }),
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#237761",
                                        },
                                        attrs: { offset: "0.2003" },
                                      }),
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#2D8A70",
                                        },
                                        attrs: { offset: "0.4783" },
                                      }),
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#3DA788",
                                        },
                                        attrs: { offset: "0.8012" },
                                      }),
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#49BD99",
                                        },
                                        attrs: { offset: "1" },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c("polygon", {
                                    staticStyle: {
                                      fill: "url(#SVGID_00000078734232224021332850000006457966955584513725_)",
                                    },
                                    attrs: {
                                      points:
                                        "448.3,497.1 422.6,512.1\n\t\t\t\t\t422.6,503.7 448.3,488.8 \t\t\t\t",
                                    },
                                  }),
                                  _c(
                                    "linearGradient",
                                    {
                                      attrs: {
                                        id: "SVGID_00000108987140357471033490000010669824786481183895_",
                                        gradientUnits: "userSpaceOnUse",
                                        x1: "422.6473",
                                        y1: "511.4253",
                                        x2: "448.2858",
                                        y2: "511.4253",
                                      },
                                    },
                                    [
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#1F715C",
                                        },
                                        attrs: { offset: "1.071477e-03" },
                                      }),
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#237761",
                                        },
                                        attrs: { offset: "0.2003" },
                                      }),
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#2D8A70",
                                        },
                                        attrs: { offset: "0.4783" },
                                      }),
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#3DA788",
                                        },
                                        attrs: { offset: "0.8012" },
                                      }),
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#49BD99",
                                        },
                                        attrs: { offset: "1" },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c("polygon", {
                                    staticStyle: {
                                      fill: "url(#SVGID_00000108987140357471033490000010669824786481183895_)",
                                    },
                                    attrs: {
                                      points:
                                        "448.3,508.2 422.6,523.1\n\t\t\t\t\t422.6,514.7 448.3,499.8 \t\t\t\t",
                                    },
                                  }),
                                  _c(
                                    "linearGradient",
                                    {
                                      attrs: {
                                        id: "SVGID_00000114789800433269113910000004061753508460524979_",
                                        gradientUnits: "userSpaceOnUse",
                                        x1: "422.6473",
                                        y1: "522.9714",
                                        x2: "448.2858",
                                        y2: "522.9714",
                                      },
                                    },
                                    [
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#1F715C",
                                        },
                                        attrs: { offset: "1.071477e-03" },
                                      }),
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#237761",
                                        },
                                        attrs: { offset: "0.2003" },
                                      }),
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#2D8A70",
                                        },
                                        attrs: { offset: "0.4783" },
                                      }),
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#3DA788",
                                        },
                                        attrs: { offset: "0.8012" },
                                      }),
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#49BD99",
                                        },
                                        attrs: { offset: "1" },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c("polygon", {
                                    staticStyle: {
                                      fill: "url(#SVGID_00000114789800433269113910000004061753508460524979_)",
                                    },
                                    attrs: {
                                      points:
                                        "448.3,519.7 422.6,534.6\n\t\t\t\t\t422.6,526.2 448.3,511.3 \t\t\t\t",
                                    },
                                  }),
                                  _c("polygon", {
                                    staticClass: "st737",
                                    attrs: {
                                      points:
                                        "422.6,523.1 415.4,527.3 415.4,518.9 422.6,514.7 \t\t\t\t",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c("polygon", {
                                staticClass: "st737",
                                attrs: {
                                  points:
                                    "422.6,534.6 415.4,538.8 415.4,530.4 422.6,526.2 \t\t\t",
                                },
                              }),
                            ]),
                            _c(
                              "g",
                              [
                                _c(
                                  "linearGradient",
                                  {
                                    attrs: {
                                      id: "SVGID_00000016075228467949321770000009931027283861299089_",
                                      gradientUnits: "userSpaceOnUse",
                                      x1: "463.0161",
                                      y1: "488.1357",
                                      x2: "488.6546",
                                      y2: "488.1357",
                                    },
                                  },
                                  [
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#1F715C" },
                                      attrs: { offset: "1.071477e-03" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#237761" },
                                      attrs: { offset: "0.2003" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#2D8A70" },
                                      attrs: { offset: "0.4783" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#3DA788" },
                                      attrs: { offset: "0.8012" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#49BD99" },
                                      attrs: { offset: "1" },
                                    }),
                                  ],
                                  1
                                ),
                                _c("polygon", {
                                  staticStyle: {
                                    fill: "url(#SVGID_00000016075228467949321770000009931027283861299089_)",
                                  },
                                  attrs: {
                                    points:
                                      "488.7,484.9 463,499.8\n\t\t\t\t463,491.4 488.7,476.5 \t\t\t",
                                  },
                                }),
                                _c(
                                  "linearGradient",
                                  {
                                    attrs: {
                                      id: "SVGID_00000167389479267566718250000007681197736974283959_",
                                      gradientUnits: "userSpaceOnUse",
                                      x1: "463.0161",
                                      y1: "499.6818",
                                      x2: "488.6546",
                                      y2: "499.6818",
                                    },
                                  },
                                  [
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#1F715C" },
                                      attrs: { offset: "1.071477e-03" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#237761" },
                                      attrs: { offset: "0.2003" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#2D8A70" },
                                      attrs: { offset: "0.4783" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#3DA788" },
                                      attrs: { offset: "0.8012" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#49BD99" },
                                      attrs: { offset: "1" },
                                    }),
                                  ],
                                  1
                                ),
                                _c("polygon", {
                                  staticStyle: {
                                    fill: "url(#SVGID_00000167389479267566718250000007681197736974283959_)",
                                  },
                                  attrs: {
                                    points:
                                      "488.7,496.4 463,511.3\n\t\t\t\t463,502.9 488.7,488 \t\t\t",
                                  },
                                }),
                                _c(
                                  "linearGradient",
                                  {
                                    attrs: {
                                      id: "SVGID_00000004508533722110546570000016739379208393671858_",
                                      gradientUnits: "userSpaceOnUse",
                                      x1: "463.0161",
                                      y1: "477.1184",
                                      x2: "488.6546",
                                      y2: "477.1184",
                                    },
                                  },
                                  [
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#1F715C" },
                                      attrs: { offset: "1.071477e-03" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#237761" },
                                      attrs: { offset: "0.2003" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#2D8A70" },
                                      attrs: { offset: "0.4783" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#3DA788" },
                                      attrs: { offset: "0.8012" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#49BD99" },
                                      attrs: { offset: "1" },
                                    }),
                                  ],
                                  1
                                ),
                                _c("polygon", {
                                  staticStyle: {
                                    fill: "url(#SVGID_00000004508533722110546570000016739379208393671858_)",
                                  },
                                  attrs: {
                                    points:
                                      "488.7,473.9 463,488.8\n\t\t\t\t463,480.4 488.7,465.5 \t\t\t",
                                  },
                                }),
                                _c("polygon", {
                                  staticClass: "st737",
                                  attrs: {
                                    points:
                                      "463,488.8 455.7,493 455.7,484.6 463,480.4 \t\t\t",
                                  },
                                }),
                                _c("polygon", {
                                  staticClass: "st737",
                                  attrs: {
                                    points:
                                      "463,499.8 455.7,504 455.7,495.6 463,491.4 \t\t\t",
                                  },
                                }),
                                _c("polygon", {
                                  staticClass: "st737",
                                  attrs: {
                                    points:
                                      "463,511.3 455.7,515.5 455.7,507.1 463,502.9 \t\t\t",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c("g", [
                              _c("polygon", {
                                staticClass: "st744",
                                attrs: {
                                  points:
                                    "407.1,512.6 407.1,533.1 285.7,603.2 285.7,583.3 \t\t\t",
                                },
                              }),
                              _c("polygon", {
                                staticClass: "st745",
                                attrs: {
                                  points:
                                    "306.9,639.5 341,619.9 341,606.1 306.9,625.7 \t\t\t",
                                },
                              }),
                              _c("polygon", {
                                staticClass: "st745",
                                attrs: {
                                  points:
                                    "307.5,614.1 341.6,594.4 341.6,580.6 307.5,600.3 \t\t\t",
                                },
                              }),
                              _c("g", [
                                _c("g", { staticClass: "st746" }, [
                                  _c("g", [
                                    _c("path", {
                                      staticClass: "st406",
                                      attrs: {
                                        d: "M290.2,684.4l117.7-68l0.3-0.2l0,21.9l-117.7,68l-0.3,0.2L290.2,684.4z M407.1,618.2l-115.7,66.8\n\t\t\t\t\t\t\tl0,19.3l115.7-66.8L407.1,618.2z",
                                      },
                                    }),
                                  ]),
                                  _c("g", [
                                    _c("path", {
                                      staticClass: "st406",
                                      attrs: {
                                        d: "M290.2,663.9l117.7-68l0.3-0.2l0,21.9l-117.7,68l-0.3,0.2L290.2,663.9z M407.1,597.7l-115.8,66.8\n\t\t\t\t\t\t\tl0,19.3l115.7-66.8L407.1,597.7z",
                                      },
                                    }),
                                  ]),
                                  _c("g", [
                                    _c("path", {
                                      staticClass: "st406",
                                      attrs: {
                                        d: "M290.2,705L408,637l0.3-0.2v21.9l-117.7,68l-0.3,0.2L290.2,705z M407.1,638.8l-115.7,66.8l0,19.3\n\t\t\t\t\t\t\tL407.1,658L407.1,638.8z",
                                      },
                                    }),
                                  ]),
                                  _c("g", [
                                    _c("path", {
                                      staticClass: "st406",
                                      attrs: {
                                        d: "M290.2,725.5l117.7-68l0.3-0.2l0,21.9l-117.7,68l-0.3,0.2L290.2,725.5z M407.1,659.3l-115.8,66.8\n\t\t\t\t\t\t\tl0,19.3l115.8-66.8L407.1,659.3z",
                                      },
                                    }),
                                  ]),
                                ]),
                                _c(
                                  "g",
                                  [
                                    _c("polygon", {
                                      staticClass: "st744",
                                      attrs: {
                                        points:
                                          "390.5,688.2 407.1,678.6 407.1,606.1 390.5,615.6 \t\t\t\t\t",
                                      },
                                    }),
                                    _c(
                                      "linearGradient",
                                      {
                                        attrs: {
                                          id: "SVGID_00000026153660570856650640000004396857877007890847_",
                                          gradientUnits: "userSpaceOnUse",
                                          x1: "-8606.9033",
                                          y1: "3495.5571",
                                          x2: "-8606.9033",
                                          y2: "3454.7732",
                                          gradientTransform:
                                            "matrix(-0.866 0.5 0 1.1548 -7071.3569 959.7469)",
                                        },
                                      },
                                      [
                                        _c("stop", {
                                          staticStyle: {
                                            "stop-color": "#1F715C",
                                          },
                                          attrs: { offset: "1.071477e-03" },
                                        }),
                                        _c("stop", {
                                          staticStyle: {
                                            "stop-color": "#237761",
                                          },
                                          attrs: { offset: "0.2003" },
                                        }),
                                        _c("stop", {
                                          staticStyle: {
                                            "stop-color": "#2D8A70",
                                          },
                                          attrs: { offset: "0.4783" },
                                        }),
                                        _c("stop", {
                                          staticStyle: {
                                            "stop-color": "#3DA788",
                                          },
                                          attrs: { offset: "0.8012" },
                                        }),
                                        _c("stop", {
                                          staticStyle: {
                                            "stop-color": "#49BD99",
                                          },
                                          attrs: { offset: "1" },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c("polygon", {
                                      staticStyle: {
                                        fill: "url(#SVGID_00000026153660570856650640000004396857877007890847_)",
                                      },
                                      attrs: {
                                        points:
                                          "373.9,697.8 390.5,688.2\n\t\t\t\t\t\t390.5,641.1 373.9,650.7 \t\t\t\t\t",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "g",
                                  [
                                    _c("polygon", {
                                      staticClass: "st744",
                                      attrs: {
                                        points:
                                          "308,735.8 324.5,726.3 324.5,672.7 308,682.3 \t\t\t\t\t",
                                      },
                                    }),
                                    _c(
                                      "linearGradient",
                                      {
                                        attrs: {
                                          id: "SVGID_00000173134994467582298300000008387786644040782733_",
                                          gradientUnits: "userSpaceOnUse",
                                          x1: "-8511.5615",
                                          y1: "3495.5562",
                                          x2: "-8511.5615",
                                          y2: "3445.1919",
                                          gradientTransform:
                                            "matrix(-0.866 0.5 0 1.1548 -7071.3569 959.7469)",
                                        },
                                      },
                                      [
                                        _c("stop", {
                                          staticStyle: {
                                            "stop-color": "#1F715C",
                                          },
                                          attrs: { offset: "1.071477e-03" },
                                        }),
                                        _c("stop", {
                                          staticStyle: {
                                            "stop-color": "#237761",
                                          },
                                          attrs: { offset: "0.2003" },
                                        }),
                                        _c("stop", {
                                          staticStyle: {
                                            "stop-color": "#2D8A70",
                                          },
                                          attrs: { offset: "0.4783" },
                                        }),
                                        _c("stop", {
                                          staticStyle: {
                                            "stop-color": "#3DA788",
                                          },
                                          attrs: { offset: "0.8012" },
                                        }),
                                        _c("stop", {
                                          staticStyle: {
                                            "stop-color": "#49BD99",
                                          },
                                          attrs: { offset: "1" },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c("polygon", {
                                      staticStyle: {
                                        fill: "url(#SVGID_00000173134994467582298300000008387786644040782733_)",
                                      },
                                      attrs: {
                                        points:
                                          "291.4,745.4 308,735.8\n\t\t\t\t\t\t308,677.7 291.4,687.3 \t\t\t\t\t",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "g",
                                  [
                                    _c("polygon", {
                                      staticClass: "st744",
                                      attrs: {
                                        points:
                                          "349.7,711.6 366.3,702 366.2,654.2 349.6,663.7 \t\t\t\t\t",
                                      },
                                    }),
                                    _c(
                                      "linearGradient",
                                      {
                                        attrs: {
                                          id: "SVGID_00000047782452153456542470000010394339015043214464_",
                                          gradientUnits: "userSpaceOnUse",
                                          x1: "-8559.6572",
                                          y1: "3495.4561",
                                          x2: "-8559.6572",
                                          y2: "3464.6196",
                                          gradientTransform:
                                            "matrix(-0.866 0.5 0 1.1548 -7071.3569 959.7469)",
                                        },
                                      },
                                      [
                                        _c("stop", {
                                          staticStyle: {
                                            "stop-color": "#1F715C",
                                          },
                                          attrs: { offset: "1.071477e-03" },
                                        }),
                                        _c("stop", {
                                          staticStyle: {
                                            "stop-color": "#237761",
                                          },
                                          attrs: { offset: "0.2003" },
                                        }),
                                        _c("stop", {
                                          staticStyle: {
                                            "stop-color": "#2D8A70",
                                          },
                                          attrs: { offset: "0.4783" },
                                        }),
                                        _c("stop", {
                                          staticStyle: {
                                            "stop-color": "#3DA788",
                                          },
                                          attrs: { offset: "0.8012" },
                                        }),
                                        _c("stop", {
                                          staticStyle: {
                                            "stop-color": "#49BD99",
                                          },
                                          attrs: { offset: "1" },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c("polygon", {
                                      staticStyle: {
                                        fill: "url(#SVGID_00000047782452153456542470000010394339015043214464_)",
                                      },
                                      attrs: {
                                        points:
                                          "333.1,721.2 349.7,711.6\n\t\t\t\t\t\t349.5,676.1 332.9,685.7 \t\t\t\t\t",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _c("polygon", {
                                staticClass: "st750",
                                attrs: {
                                  points:
                                    "290.2,649.4 302.5,642.4 302.5,628.2 290.2,635.3 \t\t\t",
                                },
                              }),
                              _c("polygon", {
                                staticClass: "st750",
                                attrs: {
                                  points:
                                    "290.2,624.8 302.5,617.8 302.5,603.6 290.2,610.7 \t\t\t",
                                },
                              }),
                              _c("polygon", {
                                staticClass: "st745",
                                attrs: {
                                  points:
                                    "375.3,574.7 405,557.9 405,544.1 375.3,560.9 \t\t\t",
                                },
                              }),
                              _c("polygon", {
                                staticClass: "st750",
                                attrs: {
                                  points:
                                    "357.9,585.5 370.2,578.4 370.2,564.3 357.9,571.3 \t\t\t",
                                },
                              }),
                              _c("polygon", {
                                staticClass: "st745",
                                attrs: {
                                  points:
                                    "375.3,599.7 405,582.9 405,569.1 375.3,586 \t\t\t",
                                },
                              }),
                              _c("polygon", {
                                staticClass: "st750",
                                attrs: {
                                  points:
                                    "357.9,610.5 370.2,603.4 370.2,589.3 357.9,596.3 \t\t\t",
                                },
                              }),
                            ]),
                          ]),
                          _c("g", [
                            _c("path", {
                              staticClass: "st709",
                              attrs: {
                                d: "M890.1,250.9l-3.9-1.5c0,0-0.1,0-0.1,0l-0.1,0l0,0c-1.6-0.5-3.6-0.2-5.8,1L593.6,415.9\n\t\t\tc-5.2,3-9.4,10.3-9.4,16.4v25.2v191.4c0,3.1,1.1,5.2,2.9,6.2l0,0l0.1,0c0.3,0.1,0.5,0.2,0.8,0.3l3.4,1.3l0-1.4\n\t\t\tc0.7-0.2,1.5-0.5,2.3-1l286.6-165.4c5.2-3,9.4-10.3,9.4-16.4V281.1v-25.2c0-2-0.5-3.6-1.3-4.7L890.1,250.9z",
                              },
                            }),
                            _c("g", [
                              _c("path", {
                                staticClass: "st697",
                                attrs: {
                                  d: "M588.3,459v191.4c0,6,4.2,8.5,9.4,5.5l286.6-165.4c5.2-3,9.4-10.3,9.4-16.4V282.6L588.3,459z",
                                },
                              }),
                              _c("path", {
                                staticClass: "st702",
                                attrs: {
                                  d: "M893.7,257.4c0-6-4.2-8.5-9.4-5.5L597.7,417.4c-5.2,3-9.4,10.3-9.4,16.4V459l305.5-176.4V257.4z",
                                },
                              }),
                            ]),
                            _c("g", [
                              _c("path", {
                                staticClass: "st727",
                                attrs: {
                                  d: "M850,289.9c0,2.6-1.8,5.8-4.1,7.2c-2.3,1.3-4.1,0.2-4.1-2.4c0-2.6,1.8-5.8,4.1-7.2\n\t\t\t\tC848.1,286.2,850,287.2,850,289.9z",
                                },
                              }),
                              _c("path", {
                                staticClass: "st728",
                                attrs: {
                                  d: "M864.9,281.2c0,2.6-1.8,5.8-4.1,7.2s-4.1,0.2-4.1-2.4c0-2.6,1.8-5.8,4.1-7.2\n\t\t\t\tC863.1,277.5,864.9,278.6,864.9,281.2z",
                                },
                              }),
                              _c("path", {
                                staticClass: "st729",
                                attrs: {
                                  d: "M879.9,272.6c0,2.6-1.8,5.8-4.1,7.2c-2.3,1.3-4.1,0.2-4.1-2.4c0-2.6,1.8-5.8,4.1-7.2\n\t\t\t\tC878.1,268.9,879.9,269.9,879.9,272.6z",
                                },
                              }),
                            ]),
                            _c("polygon", {
                              staticClass: "st730",
                              attrs: {
                                points:
                                  "887,376.2 813.3,419.9 813.3,402.2 887,358.5 \t\t",
                              },
                            }),
                            _c("polygon", {
                              staticClass: "st730",
                              attrs: {
                                points:
                                  "887,411 813.3,454.7 813.3,437 887,393.3 \t\t",
                              },
                            }),
                            _c("polygon", {
                              staticClass: "st730",
                              attrs: {
                                points:
                                  "887,476.4 813.3,520.1 813.3,471.7 887,428 \t\t",
                              },
                            }),
                            _c("g", [
                              _c(
                                "g",
                                [
                                  _c("polygon", {
                                    staticClass: "st717",
                                    attrs: {
                                      points:
                                        "820.6,357.2 813.3,361.4 813.3,353 820.6,348.8 \t\t\t\t",
                                    },
                                  }),
                                  _c(
                                    "linearGradient",
                                    {
                                      attrs: {
                                        id: "SVGID_00000048477462083317142730000001647801330545237920_",
                                        gradientUnits: "userSpaceOnUse",
                                        x1: "820.5844",
                                        y1: "345.5163",
                                        x2: "846.2228",
                                        y2: "345.5163",
                                      },
                                    },
                                    [
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#1F715C",
                                        },
                                        attrs: { offset: "1.071477e-03" },
                                      }),
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#237761",
                                        },
                                        attrs: { offset: "0.2003" },
                                      }),
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#2D8A70",
                                        },
                                        attrs: { offset: "0.4783" },
                                      }),
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#3DA788",
                                        },
                                        attrs: { offset: "0.8012" },
                                      }),
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#49BD99",
                                        },
                                        attrs: { offset: "1" },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c("polygon", {
                                    staticStyle: {
                                      fill: "url(#SVGID_00000048477462083317142730000001647801330545237920_)",
                                    },
                                    attrs: {
                                      points:
                                        "846.2,342.3 820.6,357.2\n\t\t\t\t\t820.6,348.8 846.2,333.9 \t\t\t\t",
                                    },
                                  }),
                                  _c(
                                    "linearGradient",
                                    {
                                      attrs: {
                                        id: "SVGID_00000088101795600016926420000015336370322716171162_",
                                        gradientUnits: "userSpaceOnUse",
                                        x1: "820.5844",
                                        y1: "356.5336",
                                        x2: "846.2228",
                                        y2: "356.5336",
                                      },
                                    },
                                    [
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#1F715C",
                                        },
                                        attrs: { offset: "1.071477e-03" },
                                      }),
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#237761",
                                        },
                                        attrs: { offset: "0.2003" },
                                      }),
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#2D8A70",
                                        },
                                        attrs: { offset: "0.4783" },
                                      }),
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#3DA788",
                                        },
                                        attrs: { offset: "0.8012" },
                                      }),
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#49BD99",
                                        },
                                        attrs: { offset: "1" },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c("polygon", {
                                    staticStyle: {
                                      fill: "url(#SVGID_00000088101795600016926420000015336370322716171162_)",
                                    },
                                    attrs: {
                                      points:
                                        "846.2,353.3 820.6,368.2\n\t\t\t\t\t820.6,359.8 846.2,344.9 \t\t\t\t",
                                    },
                                  }),
                                  _c(
                                    "linearGradient",
                                    {
                                      attrs: {
                                        id: "SVGID_00000119819141237363241390000008623485270492968851_",
                                        gradientUnits: "userSpaceOnUse",
                                        x1: "820.5844",
                                        y1: "368.0797",
                                        x2: "846.2228",
                                        y2: "368.0797",
                                      },
                                    },
                                    [
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#1F715C",
                                        },
                                        attrs: { offset: "1.071477e-03" },
                                      }),
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#237761",
                                        },
                                        attrs: { offset: "0.2003" },
                                      }),
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#2D8A70",
                                        },
                                        attrs: { offset: "0.4783" },
                                      }),
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#3DA788",
                                        },
                                        attrs: { offset: "0.8012" },
                                      }),
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#49BD99",
                                        },
                                        attrs: { offset: "1" },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c("polygon", {
                                    staticStyle: {
                                      fill: "url(#SVGID_00000119819141237363241390000008623485270492968851_)",
                                    },
                                    attrs: {
                                      points:
                                        "846.2,364.8 820.6,379.7\n\t\t\t\t\t820.6,371.3 846.2,356.4 \t\t\t\t",
                                    },
                                  }),
                                  _c("polygon", {
                                    staticClass: "st717",
                                    attrs: {
                                      points:
                                        "820.6,368.2 813.3,372.4 813.3,364 820.6,359.8 \t\t\t\t",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c("polygon", {
                                staticClass: "st717",
                                attrs: {
                                  points:
                                    "820.6,379.7 813.3,383.9 813.3,375.5 820.6,371.3 \t\t\t",
                                },
                              }),
                            ]),
                            _c(
                              "g",
                              [
                                _c(
                                  "linearGradient",
                                  {
                                    attrs: {
                                      id: "SVGID_00000042729910379991475140000014022886431057371266_",
                                      gradientUnits: "userSpaceOnUse",
                                      x1: "860.9532",
                                      y1: "333.2441",
                                      x2: "886.5917",
                                      y2: "333.2441",
                                    },
                                  },
                                  [
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#1F715C" },
                                      attrs: { offset: "1.071477e-03" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#237761" },
                                      attrs: { offset: "0.2003" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#2D8A70" },
                                      attrs: { offset: "0.4783" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#3DA788" },
                                      attrs: { offset: "0.8012" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#49BD99" },
                                      attrs: { offset: "1" },
                                    }),
                                  ],
                                  1
                                ),
                                _c("polygon", {
                                  staticStyle: {
                                    fill: "url(#SVGID_00000042729910379991475140000014022886431057371266_)",
                                  },
                                  attrs: {
                                    points:
                                      "886.6,330 861,344.9 861,336.5\n\t\t\t\t886.6,321.6 \t\t\t",
                                  },
                                }),
                                _c(
                                  "linearGradient",
                                  {
                                    attrs: {
                                      id: "SVGID_00000075149796203401459090000012239521255159946629_",
                                      gradientUnits: "userSpaceOnUse",
                                      x1: "860.9532",
                                      y1: "344.7902",
                                      x2: "886.5917",
                                      y2: "344.7902",
                                    },
                                  },
                                  [
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#1F715C" },
                                      attrs: { offset: "1.071477e-03" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#237761" },
                                      attrs: { offset: "0.2003" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#2D8A70" },
                                      attrs: { offset: "0.4783" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#3DA788" },
                                      attrs: { offset: "0.8012" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#49BD99" },
                                      attrs: { offset: "1" },
                                    }),
                                  ],
                                  1
                                ),
                                _c("polygon", {
                                  staticStyle: {
                                    fill: "url(#SVGID_00000075149796203401459090000012239521255159946629_)",
                                  },
                                  attrs: {
                                    points:
                                      "886.6,341.5 861,356.4\n\t\t\t\t861,348.1 886.6,333.1 \t\t\t",
                                  },
                                }),
                                _c(
                                  "linearGradient",
                                  {
                                    attrs: {
                                      id: "SVGID_00000164502947712795271730000005096433488742381718_",
                                      gradientUnits: "userSpaceOnUse",
                                      x1: "860.9532",
                                      y1: "322.2268",
                                      x2: "886.5917",
                                      y2: "322.2268",
                                    },
                                  },
                                  [
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#1F715C" },
                                      attrs: { offset: "1.071477e-03" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#237761" },
                                      attrs: { offset: "0.2003" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#2D8A70" },
                                      attrs: { offset: "0.4783" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#3DA788" },
                                      attrs: { offset: "0.8012" },
                                    }),
                                    _c("stop", {
                                      staticStyle: { "stop-color": "#49BD99" },
                                      attrs: { offset: "1" },
                                    }),
                                  ],
                                  1
                                ),
                                _c("polygon", {
                                  staticStyle: {
                                    fill: "url(#SVGID_00000164502947712795271730000005096433488742381718_)",
                                  },
                                  attrs: {
                                    points:
                                      "886.6,319 861,333.9 861,325.5\n\t\t\t\t886.6,310.6 \t\t\t",
                                  },
                                }),
                                _c("polygon", {
                                  staticClass: "st717",
                                  attrs: {
                                    points:
                                      "861,333.9 853.7,338.1 853.7,329.7 861,325.5 \t\t\t",
                                  },
                                }),
                                _c("polygon", {
                                  staticClass: "st717",
                                  attrs: {
                                    points:
                                      "861,344.9 853.7,349.1 853.7,340.7 861,336.5 \t\t\t",
                                  },
                                }),
                                _c("polygon", {
                                  staticClass: "st717",
                                  attrs: {
                                    points:
                                      "861,356.4 853.7,360.6 853.7,352.3 861,348.1 \t\t\t",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c("g", [
                              _c(
                                "g",
                                [
                                  _c("path", {
                                    staticClass: "st757",
                                    attrs: {
                                      d: "M738.7,468.8c0-30.6-21-43.5-47.2-29.6v-0.1l-2.1,1.2l-2.1,1.2v0.1c-1.1,0.7-2.3,1.5-3.5,2.3\n\t\t\t\t\tc-25,17.6-43.8,52.9-43.8,81.9c0,13,3.7,23.1,10.7,29.2c0.6,0.5,1.3,1,1.9,1.5l0,0.1l1.5,0.9c0,0,0,0,0,0l1.5,0.9l0-0.1\n\t\t\t\t\tc9.2,4.7,21.1,3.3,33.8-4c3.7-2.1,7.3-4.7,10.9-7.7l0,0.1l2-1.8c0,0,0,0,0,0l2-1.8l0,0C724.7,523.7,738.7,493.6,738.7,468.8z\n\t\t\t\t\t M679.8,513.7c-2.5-1.5-3.8-4.6-3.8-8.6c0-8.6,6-19,13.4-23.3c7.4-4.3,13.4-0.8,13.4,7.8c0,7-4.1,15.5-9.9,20.7\n\t\t\t\t\tc-1.2,1.1-2.4,1.9-3.5,2.6C685.8,514.9,682.3,515.2,679.8,513.7z",
                                    },
                                  }),
                                  _c("path", {
                                    staticClass: "st750",
                                    attrs: {
                                      d: "M689.4,515.3c-4.4,2.5-8.3,2.7-11.1,1l-22.7,38.7c8.6,5.2,20.5,4.6,33.8-3.1c4.3-2.5,8.5-5.6,12.4-9.1\n\t\t\t\t\tl-8.3-30.5C692.2,513.4,690.8,514.4,689.4,515.3z",
                                    },
                                  }),
                                  _c(
                                    "linearGradient",
                                    {
                                      attrs: {
                                        id: "SVGID_00000154394690675834223160000004569980664002169787_",
                                        gradientUnits: "userSpaceOnUse",
                                        x1: "2151.2339",
                                        y1: "3174.979",
                                        x2: "2151.2339",
                                        y2: "3082.1665",
                                        gradientTransform:
                                          "matrix(0.866 -0.5 0 1.1547 -1149.95 -2054.2354)",
                                      },
                                    },
                                    [
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#1F715C",
                                        },
                                        attrs: { offset: "1.071477e-03" },
                                      }),
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#237761",
                                        },
                                        attrs: { offset: "0.2003" },
                                      }),
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#2D8A70",
                                        },
                                        attrs: { offset: "0.4783" },
                                      }),
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#3DA788",
                                        },
                                        attrs: { offset: "0.8012" },
                                      }),
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#49BD99",
                                        },
                                        attrs: { offset: "1" },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c("path", {
                                    staticStyle: {
                                      fill: "url(#SVGID_00000154394690675834223160000004569980664002169787_)",
                                    },
                                    attrs: {
                                      d: "M736.6,470c0-30.1-21.1-42.3-47.2-27.3\n\t\t\t\t\tv36.6c8.6-5,15.5-0.9,15.5,9c0,8.3-4.9,18-11.5,23.9l8.3,30.5C721.9,524.9,736.6,495.2,736.6,470z",
                                    },
                                  }),
                                  _c("path", {
                                    staticClass: "st744",
                                    attrs: {
                                      d: "M684.1,446.2c-23.6,16.7-41.9,50.3-41.9,78.4c0,12.8,3.8,22.4,10.3,28c1,0.9,2.1,1.7,3.2,2.3l22.7-38.7\n\t\t\t\t\tc-2.7-1.7-4.4-5.1-4.4-10c0-9.9,7-22,15.5-26.9v-36.6C687.6,443.8,685.8,445,684.1,446.2z",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c("g", [
                                _c("polygon", {
                                  staticClass: "st750",
                                  attrs: {
                                    points:
                                      "735.8,433.8 735.1,433.7 746,407.2 763.2,397.3 763.2,398.2 746.5,407.8 \t\t\t\t",
                                  },
                                }),
                              ]),
                              _c("g", [
                                _c("polygon", {
                                  staticClass: "st750",
                                  attrs: {
                                    points:
                                      "652.4,472 642,464.5 615.7,479.7 615.7,478.8 642.3,463.4 653,471.1 \t\t\t\t",
                                  },
                                }),
                              ]),
                              _c("g", [
                                _c("polygon", {
                                  staticClass: "st750",
                                  attrs: {
                                    points:
                                      "756.5,530 678.3,575.2 678.3,565.2 679.1,564.7 679.1,573.8 756.5,529.1 \t\t\t\t",
                                  },
                                }),
                              ]),
                              _c("polygon", {
                                staticClass: "st737",
                                attrs: {
                                  points:
                                    "763.3,394 732,412.1 732,402 763.3,383.9 \t\t\t",
                                },
                              }),
                              _c("polygon", {
                                staticClass: "st737",
                                attrs: {
                                  points:
                                    "647,456.1 615.7,474.2 615.7,464.1 647,446 \t\t\t",
                                },
                              }),
                              _c("polygon", {
                                staticClass: "st737",
                                attrs: {
                                  points:
                                    "756.6,525 725.3,543.1 725.3,533 756.6,515 \t\t\t",
                                },
                              }),
                            ]),
                          ]),
                        ]),
                        _c("path", {
                          staticClass: "st404",
                          attrs: {
                            d: "M244.3,961.5c5.2-0.1,10.4-0.4,15.4-0.4c5.3,0,10.5,0.2,15.7,0.5c7.5,1.2,12.6,2.2,18.2,7.7\n\tc3.7,3.5,5.7,7.7,6.4,9.2c3.7,8.3,3.5,15.9,3.3,25c-0.7,8.1-1.1,9.9-3.4,17.7c-0.4,0.9-0.7,1.9-1.2,2.8c-1.4,3.2-4.8,10.7-13.3,15.6\n\tc-3.5,2-6.4,2.8-14,3.9c-6.4,0.4-12.6,0.7-19.1,0.7c-3.5,0-7.2-0.1-10.7-0.1c-5.4,0-10.8,0-16.3,0.1c0.6-7.1,1.3-14.1,1.7-21.2\n\tc0.2-5.8,0.4-11.6,0.7-17.3c0.4-8.1,0.8-16.4,1.1-24.6c0.2-6.5,0.2-13,0.4-19.5H244.3z M243.2,1030c5.4,0,11,0.1,16.3-0.2l6-0.4\n\tc0.4-0.1,3.8-0.6,5.9-1.4c2-0.7,6.4-2.6,9.6-7.5c3.7-5.7,5.7-14.6,5.7-21.2c0-3.5-0.4-17.6-13.1-22.2c-2.9-1.1-5.4-1.2-8.5-1.4\n\th-19.3L243.2,1030z",
                          },
                        }),
                      ]
                    ),
                  ]),
                ]
              },
            },
          ]),
        },
        [_c("span", [_vm._v("Dashboard")])]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }